import { RichTreeView, TreeItem, treeItemClasses } from '@mui/x-tree-view';
import React, { useEffect, useMemo, useState } from 'react';
import { styled } from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDownIcon from '@material-ui/icons/ArrowDropDown';
import { MappedTemplate } from '../types';
import { getSelectedPermissionsWithParents, getLeafNodesOnly } from '../utils';

const CustomTreeItem = styled(TreeItem)(() => ({
  [`& .${treeItemClasses.content}`]: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&[data-focused]': {
      backgroundColor: 'transparent',
    },
    '&[data-selected]': {
      backgroundColor: 'transparent',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },

  [`& .${treeItemClasses.iconContainer}`]: {
    color: 'rgba(0, 0, 0, 0.54)',
    '& svg': {
      fontSize: 24,
    },
  },
  '&.MuiTreeItem-root': {
    border: '1px solid #092241',
    borderRadius: 4,
    padding: '8px 12px',
  },

  '&.MuiTreeItem-root .MuiTreeItem-root ': {
    border: 'none',
  },

  '& .MuiTreeItem-group .MuiTreeItem-content': {
    border: 'none',
  },
}));

export const Tree = ({
  templates,
  attributes,
  isDisabled,
  handleChange,
  value,
}: {
  templates: MappedTemplate[];
  attributes?: string[];
  isDisabled?: boolean;
  value?: string[];
  handleChange?: (val: string[]) => void;
}) => {
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const mappedValue = useMemo(() => {
    return Array.from(
      getSelectedPermissionsWithParents(new Set(value || []), templates),
    );
  }, [value, templates]);

  useEffect(() => {
    if (attributes) {
      const selectedIds = new Set([...attributes]);

      const fullSelection = getSelectedPermissionsWithParents(
        selectedIds,
        templates,
      );

      setCheckedItems(Array.from(fullSelection));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes, templates]);

  const handleSelectionChange = (
    _: React.SyntheticEvent | null,
    selectedIdsFromTree: string[],
  ) => {
    setCheckedItems(selectedIdsFromTree);
    const leafNodesOnly = getLeafNodesOnly(selectedIdsFromTree, templates);
    handleChange?.(leafNodesOnly);
  };

  return (
    <RichTreeView
      slotProps={{
        root: {
          style: {
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
      slots={{
        item: CustomTreeItem,
        expandIcon: ArrowRightIcon,
        collapseIcon: ArrowDownIcon,
      }}
      checkboxSelection
      multiSelect
      items={templates}
      onSelectedItemsChange={handleSelectionChange}
      selectedItems={mappedValue}
      defaultSelectedItems={checkedItems}
      disableSelection={isDisabled}
      getItemLabel={(item: MappedTemplate) => item.label}
      selectionPropagation={{
        descendants: true,
        parents: true,
      }}
    />
  );
};
